import material_model from './material_model';
import forma_model from './forma_model';
import suaje_tipo_model from './suaje_tipo_model';
import cilindro_tipo_model from './cilindro_tipo_model';
import suaje_cilindro_adaptador_model from './suaje_cilindro_adaptador_model';

export default {
  Codigo: null,
  CodigoSuaje: null,
  CodigoSuajeTipo: null,
  TienePleca: false,
  EsAutomatica: false,
  EsCorteCompleto: false,
  MinEtiquetaImpresa: null,
  MinEtiquetaSinImpresion: null,
  Engranaje: null,
  MedidaEjeMm: null,
  MedidaDesarrolloMm: null,
  GapEjeMm: null,
  GapDesarrolloMm: null,
  MedidaEjeIn: null,
  MedidaDesarrolloIn: null,
  GapEjeIn: null,
  GapDesarrolloIn: null,
  EtiquetasEje: null,
  EtiquetasDesarrollo: null,
  AnchoOptimoMaterial: null,
  Activo: true,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  CodigoForma: null,
  Desarrollo: null,
  CodigoTipoCilindro: null,
  CodigoMaterial: null,
  Forma: { ...forma_model },
  Material: { ...material_model },
  SuajeTipo: { ...suaje_tipo_model },
  CilindroTipo: { ...cilindro_tipo_model },
};
